// Eurozone countries (use EUR currency)
const EUROZONE_COUNTRIES = [
  "AT", // Austria
  "BE", // Belgium
  "BG", // Bulgaria (joined 2026)
  "CY", // Cyprus
  "DE", // Germany
  "EE", // Estonia
  "ES", // Spain
  "FI", // Finland
  "FR", // France
  "GR", // Greece
  "HR", // Croatia
  "IE", // Ireland
  "IT", // Italy
  "LT", // Lithuania
  "LU", // Luxembourg
  "LV", // Latvia
  "MT", // Malta
  "NL", // Netherlands
  "PT", // Portugal
  "SI", // Slovenia
  "SK", // Slovakia
];

export type SupportedCurrency = "USD" | "EUR";

/**
 * Determines the currency based on the billing country.
 * Returns "EUR" for Eurozone countries, "USD" for all others.
 */
export const getCurrencyFromCountry = (countryCode: string): SupportedCurrency => {
  if (!countryCode) return "USD";
  return EUROZONE_COUNTRIES.includes(countryCode) ? "EUR" : "USD";
};
